import { parseGroupDoc } from '@db/Groups/Common';
import { getUser } from '@db/Users';
import { uniqueBy } from '@helpers/Parsers';
import { getCurrentUserId } from '@helpers/firebase/Auth';
import db, { getDocsIn } from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';
import { Group } from '@types';

export async function getGroup(groupId: string): Promise<Group> {
  const docRef = await db.getDoc(db.doc(firestore, 'groups', groupId));
  return parseGroupDoc(docRef);
}

export async function getGroupsIn(groupIds: string[]): Promise<Group[]> {
  const docs = await getDocsIn('groups', db.documentId(), 'in', groupIds);
  return docs.map((doc) => parseGroupDoc(doc));
}

export async function getUserGroups(): Promise<Group[]> {
  const [adminGroups, memberGroups] = await Promise.all([
    getUserAdminGroups(),
    getUserMemberGroups(),
  ]);
  return uniqueBy([...adminGroups, ...memberGroups], 'groupId');
}

export async function getUserAdminGroups() {
  const currentUserId = getCurrentUserId();
  const q = db.query(
    db.collection(firestore, 'groups'),
    db.where('adminIds', 'array-contains', currentUserId)
  );
  const snapshot = await db.getDocs(q);
  return snapshot.docs.map((doc) => parseGroupDoc(doc));
}

export async function getUserMemberGroups() {
  const currentUserId = getCurrentUserId();
  const user = await getUser(currentUserId);
  if (user.groupIds) {
    return await getGroupsIn(user.groupIds);
  } else {
    return [];
  }
}

export async function getLargestGroups() {
  const q = db.query(
    db.collection(firestore, 'groups'),
    db.orderBy('numMembers', 'desc'),
    db.limit(10)
  );
  const snapshot = await db.getDocs(q);
  return snapshot.docs.map((doc) => parseGroupDoc(doc));
}
